// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from "react"
import classnames from "classnames"

type Props = {
  checked?: boolean
  onChange?: (arg1: string) => void
  value?: string
  disabled?: boolean
}

const RadioButtonsRadio = ({ checked, onChange, value, disabled }: Props) => (
  <div className={classnames("RadioButtonsRadio", { _checked: checked })}>
    <div className={classnames("RadioButtonsRadio-outer", { _disabled: disabled })}>
      <div className="RadioButtonsRadio-inner" />
      {/* @ts-expect-error: Flow to TS migration. */}
      <input type="radio" onChange={onChange} checked={checked} value={value} />
    </div>
  </div>
)

export default RadioButtonsRadio
